import request from '@/utils/request/index.js'

// 货运跟踪
export function thirdApi (data) {
  return request({
    url: 'front/third_api.php',
    method: 'post',
    data
  })
}
